import DOMPurify from 'dompurify';
const ExtendedDescPopup = (props: any) => {
    const sanitizedDesc = DOMPurify?.sanitize(props?.desc) ?? "";
    return (
        <>
           <div style={{ textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: sanitizedDesc }} />
        </>
    )
}

export default ExtendedDescPopup



